/**
 * @fileoverview PATCH handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id" endpoint
 */

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

import type { CanvasStepDocument } from "../../common";
import { engagementCanvasStepCacheKeys } from "./constants";
import type { PatchCanvasStepError, PatchCanvasStepProps } from "./types";

export const patchCanvasStep = reactQueryMutationAdapter(
  engagementCanvasStepCacheKeys,
  createMutationFetcherFunctionWithShadowError<PatchCanvasStepError>()(
    ({
      app_group_id: appGroupId,
      workflow_id: workflowId,
      ...props
    }: PatchCanvasStepProps<unknown>): Promise<CanvasStepDocument> => {
      return fetch(
        `/${appGroupId}/canvas/${workflowId}/step/${props.step_id}`,
        "PATCH",
        props,
        {},
        { propagateFetchRequestError: false }
      );
    }
  )
);
